import { fabric } from "fabric";
fabric.Control.prototype.lineWidth = 2;
